import { UserRole } from '@/types'
import { httpClient } from './httpClient'

export async function getExercisesData ({ roles }: { roles: UserRole[] }) {
  try {
    const url = import.meta.env.VITE_GET_EXERCISES_ENDPOINT

    const response = await httpClient({
      baseURL: roles.includes('doctor')
        ? import.meta.env.VITE_API_MAIN_BASEURL
        : import.meta.env.VITE_API_PATIENT_BASEURL,
      url,
      method: 'GET',
      withCredentials: true
    })

    return response.data
  } catch (error) {
    console.error('getExercisesData - Error: ', error)
    throw error
  }
}
